import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { getAllBook } from "../../api/app";
import Footer from "../../components/layout/Footer";
import { truncate } from "../../utils/trunate";
import SEO from "../../components/layout/Seo";
import SlideShow from "../../components/layout/SlideShow";
import SearchInput from "../../components/layout/SearchInput";
import { FaBookOpen } from "react-icons/fa";
import { Link } from "react-router-dom";
import { formatAmount } from "../../utils/formatAmount";

//Dummy book array
//Dummy books array
export const BooksArray = [
  {
    _id: "1",
    name: "The Great Gatsby",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A novel about the American dream and the disillusionment of the Jazz Age. It explores themes of wealth, love, and the pursuit of happiness in 1920s America.",
    status: "In-stock",
  },
  {
    _id: "2",
    name: "To Kill a Mockingbird",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A powerful story about racial injustice and moral growth in the American South, seen through the eyes of a young girl named Scout Finch.",
    status: "Sold Out",
  },
  {
    _id: "3",
    name: "1984",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A dystopian novel that delves into the dangers of totalitarianism, surveillance, and the loss of individuality in a controlled society.",
    status: "In-stock",
  },
  {
    _id: "4",
    name: "Pride and Prejudice",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A classic romantic novel that explores themes of love, class, and societal expectations in 19th-century England through the story of Elizabeth Bennet and Mr. Darcy.",
    status: "Sold Out",
  },
  {
    _id: "5",
    name: "The Catcher in the Rye",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A coming-of-age story that captures the struggles of teenage rebellion and identity through the eyes of the protagonist, Holden Caulfield.",
    status: "In-stock",
  },
  {
    _id: "6",
    name: "Moby Dick",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "An epic tale of obsession and revenge, following Captain Ahab's relentless pursuit of the white whale, Moby Dick, across the seas.",
    status: "Sold Out",
  },
  {
    _id: "7",
    name: "War and Peace. Just making the title freaking long to see what happens",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A sweeping historical novel that intertwines the lives of several families during the Napoleonic Wars, exploring themes of love, war, and human resilience.",
    status: "In-stock",
  },
  {
    _id: "8",
    name: "The Odyssey",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "An ancient Greek epic poem that chronicles the adventures of Odysseus as he struggles to return home after the Trojan War, facing numerous trials and challenges along the way.",
    status: "Sold Out",
  },
  {
    _id: "9",
    name: "Crime and Punishment",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A psychological novel that delves into the moral dilemmas and mental anguish of a young man who commits a crime and grapples with guilt and redemption.",
    status: "In-stock",
  },
  {
    _id: "10",
    name: "The Hobbit",
    cover_uri: "https://images.unsplash.com/photo-1541963463532-d68292c34b19",
    price: "250",
    description:
      "A fantasy adventure that follows Bilbo Baggins, a reluctant hobbit, as he embarks on a journey to help a group of dwarves reclaim their homeland from a fearsome dragon.",
    status: "Sold Out",
  },
];

const Books = () => {
  const [loading, setLoading] = useState(true);
  const [books, setBooks] = useState(null);
  const [searchBook, setSearchBook] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllBook().then((response) => {
      if (!response.error) {
        // setBooks(response.payload);
        setBooks(BooksArray);
        setLoading(false);
      }
    });
  }, []);

  const filteredBooks = books?.filter(
    (book) =>
      book.name.toLowerCase().includes(searchBook.toLowerCase()) ||
      book.description.toLowerCase().includes(searchBook.toLowerCase())
  );

  return (
    <div>
      <SEO
        title="ZStudy | Books"
        description="Check out the varity of books available"
      />
      {loading ? (
        <div className="h-screen flex item-center justify-center">
          <div className="loader">
            <BeatLoader color="#003074" size={20} />
          </div>
        </div>
      ) : (
        <div className="container">
          {/* <div className="page-spacer"></div> */}
          <SearchInput
            searchQuery={searchBook}
            setSearchQuery={setSearchBook}
            placeholder="Search books by name..."
          />
          <div className="lg:flex lg:space-x-10">
            <div className="w-full md:space-y-10 space-y-5">
              {searchBook?.length <= 0 && (
                <div className="mt-10">
                  <SlideShow type={"stem"} />
                </div>
              )}

              <div>
                <div className="mb-2">
                  <div className="text-xl font-semibold"> Lastest Books</div>
                  <div className="text-sm mt-2">
                    {" "}
                    Choose from our highly user rated books with new additions
                    published every month.
                  </div>
                </div>

                <div className="mt-3">
                  <h4
                    className="py-3 border-b font-semibold text-grey-700  mx-1 mb-4"
                    hidden
                  >
                    <ion-icon name="star"></ion-icon>
                    Featured today
                  </h4>

                  {filteredBooks.length === 0 ? (
                    <div className="flex flex-col items-center justify-center mt-10">
                      <div>
                        <FaBookOpen className="text-8xl" />
                      </div>
                      <p className="text-center text-gray-600 text-lg">
                        Currently no books available..
                      </p>
                    </div>
                  ) : (
                    // <div className="relative" uk-slider="finite: true">
                    //   <div className="uk-slider-container px-1 py-3">
                    //     <ul className="uk-slider-items uk-child-width-1-5@m uk-child-width-1-4@s uk-child-width-1-3 uk-grid-small uk-grid text-sm font-medium text-center">
                    //       {filteredBooks?.map((item, index) => {
                    //         return (
                    //           <li>
                    //             <div className="relative overflow-hidden bg-white shadow md:rounded-lg rounded-md">
                    //               <Link key={index} to={`/book/${item._id}`}>
                    //                 <img
                    //                   src={item.cover_uri}
                    //                   alt=""
                    //                   className="w-full h-48 object-cover"
                    //                   loading="lazy"
                    //                 />
                    //                 <div className="p-3 truncate">
                    //                   {" "}
                    //                   {truncate(item.name, 30)}{" "}
                    //                 </div>
                    //               </Link>
                    //             </div>
                    //           </li>
                    //         );
                    //       })}
                    //     </ul>
                    //     <a
                    //       className="absolute bg-white top-1/4 flex items-center justify-center p-2 -left-4 rounded-full shadow-md text-xl w-9 z-10 dark:bg-gray-800 dark:text-white"
                    //       href="#"
                    //       uk-slider-item="previous"
                    //     >
                    //       {" "}
                    //       <i className="icon-feather-chevron-left"></i>
                    //     </a>
                    //     <a
                    //       className="absolute bg-white top-1/4 flex items-center justify-center p-2 -right-4 rounded-full shadow-md text-xl w-9 z-10 dark:bg-gray-800 dark:text-white"
                    //       href="#"
                    //       uk-slider-item="next"
                    //     >
                    //       {" "}
                    //       <i className="icon-feather-chevron-right"></i>
                    //     </a>
                    //   </div>
                    // </div>
                    <div class="grid grid-cols-4 gap-4">
                      {filteredBooks?.map((item, index) => {
                        return (
                          <div className="relative overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 bg-white md:rounded-lg rounded-md">
                            <Link key={index} to={`/book-details/${item._id}`}>
                              <div
                                style={{
                                  width: "100%",
                                  height: "200px",
                                  margin: "0 auto",
                                  overflow: "hidden",
                                  borderRadius: "10px",
                                  position: "relative",
                                }}
                              >
                                <img
                                  src={item.cover_uri}
                                  alt=""
                                  className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105"
                                  loading="lazy"
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                  }}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "10px",
                                    left: "10px",
                                    backgroundColor:
                                      item.status === "In-stock"
                                        ? "green"
                                        : "red",
                                    color: "white",
                                    padding: "5px 10px",
                                    borderRadius: "5px",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item.status}
                                </div>
                              </div>
                              <div className="p-4">
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: "black",
                                    lineHeight: "1.5",
                                    maxHeight: "25px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.name}
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "gray",
                                    fontWeight: "normal",
                                    lineHeight: "1.5",
                                    maxHeight: "50px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: "2",
                                  }}
                                >
                                  {item.description}
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "#003074",
                                    fontWeight: "bold",
                                    marginTop: "10px",
                                  }}
                                >
                                  {formatAmount(JSON.parse(item.price))}
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Books;
